import { useTimer, TimeObj } from "@/hooks/useCountdown";
import { dataProps } from "@/models/data.model";
import { ComponentType, FC, JSX } from "react";

type Props = dataProps & {
  UI: ComponentType<dataProps & { timeObj: TimeObj; title?: string }>;
  title?: string;
};

const CountdownPage: FC<Props> = ({ UI, title, ...data }): JSX.Element => {
  const { timeObj } = useTimer(
    data.nextChallenges?.data?.[0]?.startDate || undefined
  );

  return <UI timeObj={timeObj} title={title} {...(data as dataProps)} />;
};

export default CountdownPage;
